import {ForYouEventType} from "../types/ForYouEventType";
import {ForYouModalStep} from "../types/ForYouModalStep";

export const getDisplayEventFromState = (state: ForYouModalStep) => {
    switch (state) {
        case ForYouModalStep.CRITERIA:
            return ForYouEventType.CRITERIA;
        case ForYouModalStep.USER:
            return ForYouEventType.USER;
        case ForYouModalStep.ADDITIONAL:
            return ForYouEventType.ADDITIONAL;
        case ForYouModalStep.REGION:
            return ForYouEventType.REGION;
        default:
            return null;
    }
};
import {ForYouEventType} from "../types/ForYouEventType";
import {ForYouModalStep} from "../types/ForYouModalStep";

export const getDisplayEventFromState = (state: ForYouModalStep) => {
    switch (state) {
        case ForYouModalStep.CRITERIA:
            return ForYouEventType.CRITERIA;
        case ForYouModalStep.USER:
            return ForYouEventType.USER;
        case ForYouModalStep.ADDITIONAL:
            return ForYouEventType.ADDITIONAL;
        case ForYouModalStep.REGION:
            return ForYouEventType.REGION;
        default:
            return null;
    }
};
